import { useEffect, useState } from "react";

export const ScrollProgress = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const onScroll = () => {
            const total =
                document.documentElement.scrollHeight - window.innerHeight;
            const p = total > 0 ? (window.scrollY / total) * 100 : 0;
            setProgress(p);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div
            data-testid="scroll-progress"
            className="fixed top-0 left-0 right-0 z-[60] h-[2px] bg-transparent pointer-events-none"
        >
            <div
                className="h-full bg-[#D91C1C] shadow-[0_0_10px_rgba(217,28,28,0.8)] transition-[width] duration-150 ease-out"
                style={{ width: `${progress}%` }}
            />
        </div>
    );
};
